import SiteMenu from "../components/menu";
import ScenariosList from "../components/scenario-list";

export default function ScenariosPage() {
    return <>
        <SiteMenu />
        <ScenariosList />
    </>
}
